import moment from "moment";

import { Tooltip } from "@components/tooltip-container";
import { PrimaryButton } from "@components/v2";
import { useDateRange } from "@features/orders-v2/hooks/use-date-range";
import { type QuickFilter } from "@features/orders-v2/types";
import { DateRanges } from "@north-beam/nb-common";

const camelCaseToTitleCase = (str: string) => {
  const result = str.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const QuickFilterTooltip = ({ filter }: { filter: QuickFilter }) => {
  const { dateRange } = useDateRange();

  const formatDateRange = () => {
    if (typeof dateRange === "string") {
      return DateRanges.getLabel(dateRange);
    }

    return `${moment(dateRange.startDate).format("MM DD, YY")} - ${moment(
      dateRange.endDate,
    ).format("MM DD, YY")}`;
  };

  const renderFilterGroups = () => {
    if (filter.filters.length === 0) {
      return "-";
    }

    return filter.filters.map((f) => {
      if (Array.isArray(f.value)) {
        return (
          <div key={f.field}>
            {camelCaseToTitleCase(f.field)}:
            <ul className="list-disc pl-6 mt-1">
              {f.value.map((val) => (
                <li className="pt-.5" key={val}>
                  {val}
                </li>
              ))}
            </ul>
          </div>
        );
      } else if (f.value?.comparisonOperator) {
        return (
          <div key={f.field}>
            {camelCaseToTitleCase(f.field)}{" "}
            {camelCaseToTitleCase(f.value.comparisonOperator)} {f.value.value}
          </div>
        );
      }

      return (
        <div key={f.field}>
          {camelCaseToTitleCase(f.field)}: {f.value.value}
        </div>
      );
    });
  };

  return (
    <div>
      <div className="flex gap-1 text-xs text-v2-primary">
        <div className="flex flex-col gap-4 bg-v2-primary p-3 rounded-[4px] w-[190px] shadow-[0_0_20px_0_rgb(0,0,0,0.025)]">
          <div className="flex flex-col gap-1">
            <div className="text-v2-action border-b border-v2-tertiary pb-1 text-[10px] font-semibold">
              Date range
            </div>
            <div className="flex items-center font-light">
              {formatDateRange()}
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-v2-action border-b border-v2-tertiary pb-1 text-[10px] font-semibold">
              Filters
            </div>
            <div className="flex items-center font-light whitespace-nowrap">
              {renderFilterGroups()}
            </div>
          </div>
        </div>
      </div>
      {/* <Tooltip
        className="float-right m-3 mt-0"
        noInfoCircle
        content="Not yet implemented"
      >
        <PrimaryButton>Edit</PrimaryButton>
      </Tooltip> */}
    </div>
  );
};
